// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:575.98px){footer a{color:#fff!important;text-decoration:none}}.btn-outline-light:hover{color:#212529!important}.footer-links a:before{content:\" | \"}.footer-links a:first-child:before{content:\"\"}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
